import type { Lap } from '../../domain/lap/Lap'

/**
 * Keep only the laps the server actually recorded for the session (its
 * authoritative `lapNumber` set), dropping spurious laps that client-side
 * finish-line re-segmentation can produce when the finish line is a loose
 * single point. Order is preserved.
 *
 * Fail-open: an empty/absent stored set returns `laps` unchanged (e.g. a
 * not-yet-stored upload), so the analysis is never emptied.
 */
export function selectStoredLaps(
  laps: Lap[],
  storedLapNumbers: number[]
): Lap[] {
  if (storedLapNumbers.length === 0) {
    return laps
  }
  const stored = new Set(storedLapNumbers)
  return laps.filter((lap) => stored.has(lap.lapNumber))
}
